module.exports = __webpack_public_path__ + "img/cv-template-2.42269e23.png";